const sidebar = false;

const entity = {
  title: "Users",
  actions: {
    sort: {
      endPoint: "users/by",
      query: {
        $order: {},
      }
    },
    get: {
      endPoint: "users/by",
      query: {}
    },
    create: {
      endPoint: "users"
    },
    filter: {
      endPoint: "users/by",
      query: {
        $group: "id",
        $where: {}
      }
    }
  }
};

const keys = [{
  dataTableID: "id",
  tooltip: "ID used to generate this report",
  label: "Id",
  columnType: "string",
  table: {
    displayOrder: 1
  },
  filter: {
    displayOrder: 1,
    columnType: "select",
    matchType: "", // Values can be gte, lte, gt, lt, By default it is eq
    options: {
      select: [{
        field: "id"
      }],
      title: ["id"],
      value: "id",
      endPoint: "users/by",
      separator: " ",
      initializer: ""
    }
  }
},
{
  dataTableID: "name",
  tooltip: "Name of the user",
  label: "Name",
  columnType: "string",
  create: {
    displayOrder: 1
  },
  table: {
    displayOrder: 2
  },
  filter: {
    displayOrder: 2
  }
}
];

const tabs = [{
  view: "detailView",
  entity: "users",
  endPoint: "users/by",
  title: "Details",
  queryFilter: {
    id: ":id"
  }
}];

export {
  sidebar,
  entity,
  keys,
  tabs
};